import React from 'react';
import { RGBA_COLORS } from '../../../../utils/colors';
import { IconSmile } from '../../../svgs/IconSmile';
import { IconCry } from '../../../svgs/IconCry';

interface Props {
  balls: number;
  needBalls: number;
  success: boolean;
}

export const PollResult: React.FC<Props> = ({ success, balls, needBalls }) => {
  return (
    <div style={{ padding: '20px 50px' }}>
      <div style={{ width: '100%' }}>
        <div className="tda__wrapper" style={{ width: '100%' }}>
          {success ? (
            <>
              <IconSmile />
              <h2>
                Вітаю! За данний інтерактив Ви набрали <span style={{ color: RGBA_COLORS.getAccent() }}>{balls}</span> балів! Загальна кількість балів
                складає <span style={{ color: RGBA_COLORS.getAccent() }}>{needBalls}</span>
              </h2>
            </>
          ) : (
            <>
              <IconCry />
              <h2>
                Шкода, відповідь невірна. За данний інтерактив, Ви не отримали балів Загальна кількість балів складає{' '}
                <span style={{ color: RGBA_COLORS.getAccent() }}>{needBalls}</span>{' '}
              </h2>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
